import * as angular from "angular";
import {IController} from "angular";

export class AgentsFilterStatusSelectCtrl implements IController {

  selectedStatus: any;

  statusChanged: Function;

  constructor(private agentStatus) {
  }

  $onInit() {

  }

  selectStatus(status) {
    this.selectedStatus = status;
    this.statusChanged({status: status});
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsFilterStatusSelect', {
    bindings: {
      selectedStatus: '<',
      statusChanged: '&'
    },
    template: require('./agents-filter-status-select.html').default,
    controller: AgentsFilterStatusSelectCtrl
  });
